module.exports = __webpack_public_path__ + "media/images/empresa/emp_cred3-a8f0ae30ecd50f8b8da56641d5ed8597.svg";